import api from './apiClient';

// Lambda-backed service for the "services" collection
const collection = '/services';

const serviceService = {
  async getListData() {
    return await api.get(collection);
  },
  async getListObjectDataById(id) {
    return await api.get(`${collection}/${encodeURIComponent(id)}`);
  },
  async updateListObjectDataById(id, patch) {
    const body = patch && typeof patch === 'object' ? patch : {};
    return await api.put(`${collection}/${encodeURIComponent(id)}`, body);
  },
  async insertObjectToArrayData(obj) {
    const body = obj && typeof obj === 'object' ? obj : {};
    return await api.post(collection, body);
  },
  async deleteObjectInArrayData(id) {
    await api.delete(`${collection}/${encodeURIComponent(id)}`);
    return true;
  },
};

export default serviceService;
